import React, { Component } from "react";

import { GetPhotos } from "../../utils/consts";
import { ListingContext, UserContext } from "../../Context";

import PhotosBtn from "../photosBtn/PhotosBtn";
import ListingFav from "../ListingFav/ListingFav";
import SkeletonTitle from "../skeleton/SkeletonTitle";

import Lightbox from "react-images";

import "./listingHeader.css";
export default class ListingHeader extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      currentImageIndex: 0
    };
  }

  componentDidMount() {
    if (!!this.props.lid) {
      this.getPhotos(this.props.lid);
    }
  }

  getPhotos = lid => {
    GetPhotos(lid)
      .then(photosObj => {
        let photos = photosObj[lid];
        if (!!photosObj) {
          photos = Object.values(photos);
        } else {
          photos = [];
        }
        this.setState({ photos });
      })
      .catch(error => console.log(error));
  };

  openHandler = () =>
    this.setState({ open: !this.state.open, currentImageIndex: 0 });
  nextImageHandler = () =>
    this.setState({ currentImageIndex: this.state.currentImageIndex + 1 });
  prevImageHandler = () =>
    this.setState({ currentImageIndex: this.state.currentImageIndex - 1 });
  handleClickImage = () => {
    this.state.currentImageIndex !== this.state.photos.length - 1 &&
      this.nextImageHandler();
  };
  gotoImage = index => this.setState({ currentImageIndex: index });

  render() {
    return (
      <UserContext.Consumer>
        {userContext => {
          return (
            <ListingContext.Consumer>
              {listingContext => {
                const listing = listingContext.listing || {};
                const photos = this.state.photos || [];
                const preview = listing.preview || "";
                return (
                  <div
                    className="banner"
                    onClick={!!photos.length ? this.openHandler : null}
                    style={
                      !!listing.preview
                        ? {
                            backgroundImage: `url(data:image/jpeg;base64,${preview})`
                          }
                        : { cursor: "default" }
                    }
                  >
                    {listingContext.loading && <SkeletonTitle />}
                    {!this.props.hideTitle &&
                      !listing.preview &&
                      !listingContext.loading &&
                      !!listing.title && (
                        <h3 className="banner__title">{listing.title}</h3>
                      )}
                    {}
                    {!!photos.length && (
                      <PhotosBtn
                        btnClick={this.openHandler}
                        title={listing.title}
                      />
                    )}
                    {!!photos.length && (
                      <Lightbox
                        images={photos.map(photo => {
                          return {
                            src: `data:image/png;base64,${photo}`,
                            alt: listing.title,
                            srcSet: [`data:image/png;base64,${photo}`]
                          };
                        })}
                        isOpen={this.state.open}
                        onClose={this.openHandler}
                        backdropClosesModal={true}
                        showThumbnails={true}
                        currentImage={this.state.currentImageIndex}
                        handleClickImage={this.handleClickImage}
                        onClickThumbnail={this.gotoImage}
                        onClickPrev={this.prevImageHandler}
                        onClickNext={this.nextImageHandler}
                      />
                    )}
                    <ListingFav
                      addFlag={userContext.addFlag}
                      lid={listing.lid}
                    />
                  </div>
                );
              }}
            </ListingContext.Consumer>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/listingHeader/ListingHeader.js